import React from 'react';
import mastercard from 'assets/images/mastercard.svg';
import { SvgIconProps } from '@mui/material';

export const AfMastercardIcon: React.FC<SvgIconProps> = () => {
  return <img src={mastercard} />;
};
